import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./AuthPage.css";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Toggle password visibility for password
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Toggle password visibility for confirm password

  const auth = getAuth();
  const navigate = useNavigate();

  // Handle Email Signup
  const handleEmailSignup = async () => {
    if (password !== confirmPassword) {
      setMessage("Passwords do not match!");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      setMessage(`Sign-up successful! Welcome, ${name || "User"}`);
      navigate("/"); // Redirect to homepage
    } catch (error) {
      console.error("Error signing up with email and password:", error.message);
      setMessage("Failed to sign up. Please try again.");
    }
  };

  // Handle Google Signup
  const handleGoogleSignup = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      setMessage(`Welcome, ${result.user.displayName || "Google User"}!`);
      navigate("/"); // Redirect to homepage
    } catch (error) {
      console.error("Google sign-in error:", error.message);
      setMessage("Failed to sign in with Google. Please try again.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Sign up</h2>
        <input
          type="text"
          placeholder="Enter Your Name..."
          className="auth-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Enter Your Email..."
          className="auth-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="password-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password..."
            className="auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <img
            src={showPassword ? "/eye-open-icon.png" : "/eye-closed-icon.png"}
            alt="Toggle Password Visibility"
            className="toggle-password-icon"
            onClick={() => setShowPassword(!showPassword)}
          />
        </div>
        <div className="password-container">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Your Password..."
            className="auth-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <img
            src={showConfirmPassword ? "/eye-open-icon.png" : "/eye-closed-icon.png"}
            alt="Toggle Confirm Password Visibility"
            className="toggle-password-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          />
        </div>
        <p>
          Already have an account? <a href="/auth/login" className="auth-link">Log in</a>
        </p>
        <button className="auth-button" onClick={handleEmailSignup}>
          Sign Up
        </button>
        <button className="google-button" onClick={handleGoogleSignup}>
          <img src="/google-icon.png" alt="Google" />
          Login with Google
        </button>
        {message && <p className="auth-message">{message}</p>}
      </div>
      <img src="/auth-image-16.png" alt="Auth Illustration" className="auth-image" />
      <div className="auth-dots">
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
};

export default Signup;
